"use strict";
import $ from "jquery";
import Auth from "../util/auth";
import Honeybadger from "@honeybadger-io/js";
var ApiService = {
  errorHandlerWithMessage: function(message, additionalContext) {
    var self = this;
    return function(result) {
      var _a, _b, _c, _d, _e;
      var url = null;
      var params = null;
      var requestId = null;
      var errorMessage = null;
      if (result) {
        errorMessage = result.message;
        url = result.url;
        params = result.data;
        requestId = (_a = result.getResponseHeader) == null ? void 0 : _a.call(result, "x-request-id");
        if (result.response) {
          requestId = (_b = result.response.headers) == null ? void 0 : _b.get("x-request-id");
          errorMessage = errorMessage || ((_c = result.response.data) == null ? void 0 : _c.error);
        }
      }
      var errorDetails = {};
      const user = Auth._currentUser;
      errorDetails = {
        errorMessage,
        status: result.status,
        url,
        params,
        user: {
          id: user.id,
          email: user.email,
          account_alias: user.account.alias
        },
        statusText: result.statusText,
        requestId,
        additionalContext
      };
      var jsonErrorMessage = null;
      if (result.responseJSON) {
        jsonErrorMessage = result.responseJSON.error_message;
      }
      var msg = jsonErrorMessage || result.status === 0 && "Unable to connect to TriumphPay Audit. Please check your network connection and try again." || message;
      if (((_e = result.status) != null ? _e : (_d = result.response) == null ? void 0 : _d.status) === 401) {
        Auth.reset();
        window.location.href = "/app/login";
      }
      if (result.status !== 422) {
        Honeybadger.notify(result, {
          message: msg,
          name: "Handled Web Request Error: " + (errorMessage || msg),
          context: errorDetails
        });
      }
      $(self).trigger("ApiService:alertError", [
        { message: msg, details: errorDetails }
      ]);
      return Promise.reject(result);
    };
  },
  addErrorHandler: function(promise, message = null, additionalContext = null) {
    return Promise.resolve(promise).catch(
      this.errorHandlerWithMessage(
        message || "An unexpected error occurred, please try again.",
        additionalContext
      )
    );
  }
};
export default ApiService;
